// Role-based access control utilities

export const getRoleDetails = () => {
    const roleDetailsStr = localStorage.getItem("roleDetails");
    if (roleDetailsStr) {
        try {
            return JSON.parse(roleDetailsStr);
        } catch (e) {
            console.error("Error parsing role details:", e);
            return null;
        }
    }
    return null;
};

export const getRole = () => {
    return localStorage.getItem("role");
};

export const getRoleName = () => {
    const roleDetails = getRoleDetails();
    if (roleDetails && roleDetails.name) {
        return roleDetails.name;
    }
    
    const role = getRole();
    // Map role strings to display names
    const roleMap = {
        'super_admin': 'Super Administrator',
        'uni_admin': 'University Administrator', 
        'multi_user': 'Multi-User',
        'user': 'User'
    };
    
    return roleMap[role] || role;
};

export const hasRole = (requiredRole) => {
    const role = getRole();
    const roleDetails = getRoleDetails();
    
    // Check legacy role string
    if (role === requiredRole) return true;
    
    // Check new role system
    if (roleDetails && roleDetails.name === requiredRole) return true;
    
    return false;
};

export const hasAnyRole = (requiredRoles) => {
    return requiredRoles.some(role => hasRole(role));
};

export const isSuperAdmin = () => {
    return hasRole("super_admin");
};

export const isUniAdmin = () => {
    return hasRole("uni_admin");
};

export const isMultiUser = () => {
    return hasRole("multi_user");
};

export const isUser = () => {
    return hasRole("user");
};

// Permission-based access control
export const canAccessCRM = () => {
    return hasAnyRole(["super_admin", "uni_admin", "multi_user"]);
};

export const canAccessUserManagement = () => {
    return hasAnyRole(["super_admin", "uni_admin", "multi_user"]);
};

export const canAccessUniversityManagement = () => {
    return hasRole("super_admin");
};

export const canAccessAnalytics = () => {
    return true; // All users can access analytics
};

export const canAccessReports = () => {
    return hasAnyRole(["super_admin", "uni_admin", "multi_user"]);
};

export const canAccessIntegrations = () => {
    return hasAnyRole(["super_admin", "uni_admin", "multi_user"]);
};

export const canAccessSettings = () => {
    return hasAnyRole(["super_admin", "uni_admin", "multi_user"]);
};

export const canAccessMultiUserTours = () => {
    const multiUser = localStorage.getItem("multiUser");
    return multiUser === "true" || hasRole("multi_user");
}; 